const formatMoney = (amount) => {
  return new Intl.NumberFormat("en-MY", {
    style: "currency",
    currency: "MYR",
    minimumFractionDigits: 2,
  }).format(amount || 0);
};

export const LoanLedgerSummary = ({ loan, summary }) => {
  const profitTone = summary.net_profit_loss >= 0 ? "profit-positive" : "profit-negative";

  return (
    <section className="repayment-ledger-summary ledger-page-summary">
      <div>
        <span>Loan total</span>
        <strong>{formatMoney(loan.principal)}</strong>
      </div>
      <div>
        <span>Cash on hand</span>
        <strong>{formatMoney(summary.cash_on_hand)}</strong>
      </div>
      <div>
        <span>Total Collect</span>
        <strong>{formatMoney(summary.total_received)}</strong>
      </div>
      <div>
        <span>Balance Remain</span>
        <strong>{formatMoney(summary.remaining_balance)}</strong>
      </div>
      <div className={profitTone}>
        <span>Net profit / loss so far</span>
        <strong data-testid="net-profit-loss-value">
          {formatMoney(summary.net_profit_loss)}
        </strong>
      </div>
      <div>
        <span>Projected profit at settlement</span>
        <strong>{formatMoney(summary.projected_profit)}</strong>
      </div>
    </section>
  );
};